import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    flexShrink: 0,
    position: 'relative',
    zIndex: 1100,
    backgroundColor: semanticColors.background.primary,
    boxShadow: '0px 2px 8px rgba(0,0,0,0.12)'
  },
  primaryRow: {
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  secondaryRow: {
    padding: '8px 24px',
    borderTop: `1px solid ${semanticColors.border.secondary}`,
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  storySelectContainer: {
    width: '40%'
  }
});
